import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'

import {BoomTown} from './routes/BoomTown'
import {DiversityIndex} from './routes/about/diversity/DiversityIndex'
import {Home} from './routes/home/Index'
import {ShowPage} from './routes/ShowPage'
import {ThankYouPage} from './routes/ThankYouPage'
import EventsUniverseRecapIndex from './routes/events/universe/recap/Index'
import FeaturesCopilotIndex from './routes/features/copilot/Index'
import FeaturesCopilotPlansIndex from './routes/features/copilot/plans/Index'
import FeaturesCopilotAiCodeEditorIndex from './routes/features/copilot/ai-code-editor/Index'
import SecurityAdvancedSecurityIndex from './routes/security/advanced-security/Index'
import SecurityPlansIndex from './routes/security/plans/Index'
import {GitHubAppWaitlistPage} from './routes/features/preview/github-app/Index'
import {GitHubAppGAPage} from './routes/features/ai/github-app/Index'

registerNavigatorApp('landing-pages', () => ({
  App,
  routes: [
    jsonRoute({path: '/about/diversity', Component: DiversityIndex}),
    jsonRoute({path: '/contact-sales/thank-you', Component: ThankYouPage}),
    jsonRoute({path: '/enterprise/contact/thanks', Component: ThankYouPage}),
    jsonRoute({path: '/events/universe/recap', Component: EventsUniverseRecapIndex}),
    jsonRoute({path: '/features/ai/github-app', Component: GitHubAppGAPage}),
    jsonRoute({path: '/features/copilot', Component: FeaturesCopilotIndex}),
    jsonRoute({path: '/features/copilot/plans', Component: FeaturesCopilotPlansIndex}),
    jsonRoute({path: '/features/copilot/ai-code-editor', Component: FeaturesCopilotAiCodeEditorIndex}),
    jsonRoute({path: '/features/preview/github-app', Component: GitHubAppWaitlistPage}),
    jsonRoute({path: '/home', Component: Home}),
    jsonRoute({path: '/security/advanced-security', Component: SecurityAdvancedSecurityIndex}),
    jsonRoute({path: '/security/plans', Component: SecurityPlansIndex}),

    /**
     * We use this route to exercise error handling and exception reporting.
     * in the app. The BoomTown component simply throws an error when it renders.
     */
    jsonRoute({path: '/contentful-lp-tests/boomtown', Component: BoomTown}),

    jsonRoute({path: '*', Component: ShowPage}),
  ],
}))
